// extracted by extract-css-chunks-webpack-plugin
module.exports = {"searchInput":"navbar__searchInput__20nGh","focus":"navbar__focus__1Z_tP"};